<template>
  <div class="user-management">
    <ry-sb
      ref="child"
      :declareType="1"
    />
  </div>
</template>

<script>
  import RySb from "@/components/sbgl/rysb.vue";
  export default {
    name: "person-management",
    components: { RySb },
    props: {},
    data() {
      return {
      };
    },
    methods: {
    },
    created() {
    },
  };
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/views/sbgl/qyrysb.vue